import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ProfileComponent } from "./components/Profile";
import { HomeComponent } from "./components/Home/Home";
import { SignInComponent } from "./components/Auth/Signin";
import { AttendenceComponent } from "./components/Attendance/Attendance";
import { LeavesComponent } from "./components/Leaves/Leaves";
import { LeaveSummaryComponent } from "./components/Leaves/LeaveSummary";
import { HeaderComponent } from "./components/Config/header";
import { FooterComponent } from "./components/Config/footer";
import { LeaveApplicationComponent } from "./components/Team/LeaveApplication";
import ProtectedRoute from "./components/Config/protectedroute";
import About from "./components/Config/About";
import Menu from "./components/Menu/Menu";
import Team from "./components/Team/Team";
import Subscribe from "./components/Config/Subscribe";
import ChangePassword from "./components/Auth/ChangePassword";
import Maps from "./components/Home/Maps";
import Notifications from "./components/Notifications/Notifications";

function App() {
  const isLoggedIn = !!sessionStorage.getItem("userData");

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<SignInComponent />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileComponent />
              </ProtectedRoute>
            }
          />
          <Route path="/Attendance" element={<AttendenceComponent />} />
          <Route path="/Leaves" element={<LeavesComponent />} />
          <Route path="/LeaveSummary" element={<LeaveSummaryComponent />} />
          <Route path="/Home" element={<HomeComponent />} />
          <Route path="/Header" element={<HeaderComponent />} />
          <Route path="/Footer" element={<FooterComponent />} />
          {/* <Route path="/TeamMembers" element={<TeamMumbersComponent />} /> */}
          {/* <Route
            path="/MonthlyAttendance"
            element={<MonthlyAttandanceComponent />}
          /> */}
          {/* <Route
            path="/ManualAttendance"
            element={<ManualAttandanceComponent />}
          /> */}
          {/* <Route path="/BulkAttendance" element={<BulkAttandanceComponent />} /> */}
          <Route
            path="/LeaveApplication"
            element={<LeaveApplicationComponent />}
          />
          {/* <Route path="/Holidays" element={<Holidays />} /> */}
          <Route path="/About" element={<About />} />
          {/* <Route path="/Notifications" element={<Notifications />} /> */}
          <Route path="/Menu" element={<Menu />} />
          <Route path="/Team" element={<Team />} />
          {/* <Route path="/TeamPendingLeaves" element={<TeamPendingLeaves />} /> */}
          {/* <Route path="/Meeting" element={<MeetingComponent />} /> */}
          <Route path="/Subscribe" element={<Subscribe />} />
          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/maps" element={<Maps />} />
          <Route path="/notifications" element={<Notifications />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
